import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useParams } from 'react-router-dom';
import '../styles/Lead.css';

function Visite() {
  const { id } = useParams();
  const [visite, setVisite] = useState([]);
  const [alloggiVendite, setAlloggiVendite] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [sort, setSort] = useState('data_visita');
  const [formData, setFormData] = useState({
    data_visita: '',
    cliente: '',
    alloggio: '',
    note: ''
  });

  const fetchVisite = useCallback(async () => {
    const res = await api.get(`/visite/${id}`);
    setVisite(res.data);
  }, [id]);

  const fetchAlloggiVendite = useCallback(async () => {
    const res = await api.get(`/vendite/cantiere/${id}`);
    setAlloggiVendite(res.data);
  }, [id]);

  useEffect(() => {
    fetchVisite();
    fetchAlloggiVendite();
  }, [fetchVisite, fetchAlloggiVendite]);


  const sortedVisite = [...visite].sort((a,b)=>{
    if(sort==='cliente') return a.cliente.localeCompare(b.cliente);
    return new Date(a.data_visita) - new Date(b.data_visita);
  });

  const openForm = (v=null)=>{
    if(v){
      setFormData({
        ...v,
        data_visita: v.data_visita ? v.data_visita.split('T')[0] : ''
      });
      setEditing(v.id);
    }
    else {
      setFormData({data_visita:'',cliente:'',alloggio:'',note:''});
      setEditing(null);
    }
    setShowForm(true);
  };

  const handleChange = e => setFormData({...formData,[e.target.name]:e.target.value});

  const handleSubmit = async (e)=>{
    e.preventDefault();
    const payload = { ...formData, cantiere_id: id };
    if(editing) await api.put(`/visite/${editing}`, payload);
    else await api.post(`/visite`, payload);
    setShowForm(false);
    fetchVisite();
  };

  const handleDelete = async (vid)=>{
    if(window.confirm('Eliminare questa visita?')){
      await api.delete(`/visite/${vid}`);
      fetchVisite();
    }
  };

  return (
    <div className="sezione">
      <div className="sezione-title">
        <h2>Visite</h2>
      </div>
      <div className="sezione-sort">
        <select className="sort-select" value={sort} onChange={e=>setSort(e.target.value)}>
          <option value="data_visita">Ordina per data</option>
          <option value="cliente">Ordina per nome</option>
        </select>
        <button type="button" className="btn-aggiungi" onClick={()=>openForm()}>➕ Aggiungi Visita</button>
      </div>
      {showForm && (
        <div className="modal-overlay">
          <div className="modal-visite">
            <button type="button" className="close-button" onClick={() => setShowForm(false)}>✖</button>
            <form onSubmit={handleSubmit} className="form-visita">
              <div className="form-grid-lead">
                <div className="form-group-lead">
                  <label htmlFor="Data Visita">Data Visita</label>
                  <input type="date" name="data_visita" placeholder="Data Visita" value={formData.data_visita} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Cliente">Cliente</label>
                  <input name="cliente" placeholder="Cliente" value={formData.cliente} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="alloggio">Alloggio</label>
                  <select className="custom-select" name="alloggio" value={formData.alloggio} onChange={handleChange} required>
                    <option value="">Seleziona Alloggio</option>
                    {alloggiVendite.map(a => (
                      <option key={a.id} value={a.alloggio}>{a.alloggio}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group-lead">
                  <label htmlFor="note">Note</label>
                  <input name="note" placeholder="Note" value={formData.note} onChange={handleChange} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-annulla" onClick={()=>setShowForm(false)}>Annulla</button>
                <button type="submit" className="btn-aggiungi">Salva</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <div className="card-container">
        {sortedVisite.map(v=> (
          <div className="card" key={v.id}>
            <div className="card-header">Visita · {v.data_visita}
              <div>
                <button type="button" onClick={()=>openForm(v)}>✏️</button>
                <button type="button" onClick={()=>handleDelete(v.id)}>🗑️</button>
              </div>
            </div>
            <div className="card-body">
              <p><strong>Cliente:</strong> {v.cliente}</p>
              <p><strong>Alloggio:</strong> {v.alloggio}</p>
              <p><strong>Note:</strong> {v.note}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Visite;

